import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../state/store";
import { stat } from "fs";

export interface SelectionState {
    modCategory: string;
    email: string;
    colourSelection: { [key: string]: string };
    modSelection: { [key: string]: string };
    disclaimerChecked: boolean;
}

const emptyColourSelection: { [key: string]: string } = {
    "D-pad": "#000000",
    AB: "#310101",
    StartSelect: "#070707",
    Lens: "#373737",
    Shell: "#373528",
};

const emptyModSelection: { [key: string]: string } = {
    Screen: "None",
    AudioSpeaker: "None",
    AudioMod: "None",
    Power: "None",
    Battery: "None",
    LED: "None",
    Other: "None",
};

export const selectionSlice = createSlice({
    name: "selection",
    initialState: {
        modCategory: "Colours",
        email: "",
        colourSelection: emptyColourSelection,
        modSelection: emptyModSelection,
        disclaimerChecked: false,
    },
    reducers: {
        updateModCategory: (state, action: PayloadAction<string>) => {
            state.modCategory = action.payload;
        },
        updateEmail: (state, action: PayloadAction<string>) => {
            state.email = action.payload;
        },
        updateColourSelection: (
            state,
            action: PayloadAction<{ [key: string]: string }>
        ) => {
            state.colourSelection = action.payload;
        },
        updateModSelection: (
            state,
            action: PayloadAction<{ [key: string]: string }>
        ) => {
            state.modSelection = action.payload;
        },
        updateDisclaimerChecked: (state, action: PayloadAction<boolean>) => {
            state.disclaimerChecked = action.payload;
        },
    },
});

export const {
    updateModCategory,
    updateEmail,
    updateColourSelection,
    updateModSelection,
    updateDisclaimerChecked,
} = selectionSlice.actions;

export const selectModCategory = (state: RootState) =>
    state.selection.modCategory;
export const selectEmail = (state: RootState) => state.selection.email;

export const selectColourSelection = (state: RootState) =>
    state.selection.colourSelection;
export const selectModSelection = (state: RootState) =>
    state.selection.modSelection;
export const selectDisclaimerChecked = (state: RootState) =>
    state.selection.disclaimerChecked;

export default selectionSlice.reducer;
